import styled from "styled-components";

export default styled.div`
  display: flex;
  flex-flow: column wrap;
  align-items: flex-end;
  justify-content: space-between;
  height: 400px;
  position: absolute;
  left: -240px;
  top: 0px;
`;
